
import React, { createContext, useState, useContext } from "react";

const GeradoresEstacionariosContext = createContext();

export default function AmbienteProvider({ children }) {
  const [energiaGerador_id, setEnergiaGerador_id] = useState();

  return (
    <GeradoresEstacionariosContext.Provider value={{ energiaGerador_id, setEnergiaGerador_id }} >
      {children}
    </GeradoresEstacionariosContext.Provider>
  );
}

export function useGeradoresEstacionariosContext() {
  const context = useContext(GeradoresEstacionariosContext);
  //if (!context) throw new Error("useCount must be used within a CountProvider");
  const { energiaGerador_id, setEnergiaGerador_id } = context;
  return { energiaGerador_id, setEnergiaGerador_id };
}

